import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createRootRoute, Outlet, } from '@tanstack/react-router';
import { useEffect, } from 'react';
import { useTranslation, } from '../../useTranslation.js';
export const Route = createRootRoute({
    // TanStack merges all search params from the hierarchy of routes.
    // Therefore, if search params are removed from child routes,
    // they will reintroduced by this parent route. Therefore,
    // everything is removed there
    validateSearch: () => ({}),
    component: RootComponent,
});
function RootComponent() {
    const tRoot = useTranslation();
    useEffect(() => {
        document.documentElement.lang = tRoot.locale;
        document.documentElement.dir = tRoot.dir;
    }, [tRoot.locale, tRoot.dir]);
    return (_jsx(_Fragment, { children: _jsx(Outlet, {}) }));
}
//# sourceMappingURL=__root.js.map